<template>
  <div class="mt-3 mt-md-4">
    <div class="font-size-sm font-weight-bold color-text-dark" v-if="cartItem.experiences.length">
      {{ i18n.chooseExperiences }}
    </div>

    <div
      v-for="(experience, index) in cartItem.experiences"
      :key="experience.id"
      class="accommodation-option mt-3"
    >
      <input
        type="checkbox"
        :id="`cart-item-experience-${experience.id}`"
        :name="`cart-item-experience-${experience.id}`"
        :value="experience.id"
        :checked="experience.selected"
        :disabled="experience.disabled"
        @change="({ currentTarget }) => onCartItemExperienceChange([
          currentTarget.checked,
          cartItem,
          experience.id,
          experience.quantity,
        ])"
      >

      <label :for="`cart-item-experience-${experience.id}`">
        {{ experience.description }}

        <span class="color-primary font-weight-bold">
          <template v-if="parseFloat(experience.price) > 0">
            €{{ experience.price }} {{ experience.priceUnitType === 'pppn' ? i18n.perPersonAbbreviation : '' }}
          </template>
        </span>

        <div class="mt-2">
          <div class="d-flex align-items-center">
            <div class="custom-select custom-select--small">
              <select
                class="form-control"
                :id="`cart-item-experience-${experience.id}-amount-of-persons`"
                :disabled="!experience.selected"
                v-model="experience.quantity"
                @change="({ currentTarget }) => onCartItemExperienceChange([
                  experience.selected,
                  cartItem,
                  experience.id,
                  currentTarget.value,
                ])"
              >
                <option
                  v-for="(amountOfPersons, index) in experience.unitOptions"
                  :key="index"
                  :value="amountOfPersons"
                >
                  {{ amountOfPersons }}
                </option>
              </select>

              <Icon name="arrow-down" />
            </div>

            <label
              :for="`cart-item-experience-${experience.id}-amount-of-persons`"
              class="form-label color-text-dark text-lowercase ml-3 mb-0"
            >
              {{ experience.isUnitExperience ? i18n.person : i18n.persons }}
            </label>
          </div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Icon from '@/cart/components/Icon.vue';

export default {
  components: {
    Icon,
  },

  props: {
    cartItem: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions([
      'onCartItemExperienceChange',
    ]),
  },
};
</script>
